exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: Klavika Regular;\n  src: url(\"/fonts/klavika/Klavika-Regular.ttf\");\n}", ""]);

// exports
